import axios from 'axios';
import { config } from '../../../config/env';
import { AcquisitionOffer, AuthenticatedOffer } from './types';

const baseUrl = config.jusfyBackend.apiUrl;
const acquisitionUrl = `${baseUrl}/pricing-catalog/acquisition`;
const offersUrl = `${baseUrl}/pricing-catalog/offers`;

export async function getAcquisitionOffers(coupon?: string): Promise<AcquisitionOffer[]> {
  const params = coupon ? { coupon } : undefined;
  const { data } = await axios.get<{ success: true; data: AcquisitionOffer[] }>(acquisitionUrl, { params });
  return data.data;
}

// jwtAuth: cliente vem do JWT (interceptor global já injeta o Bearer), sem
// query params.
export async function getAuthenticatedOffers(): Promise<AuthenticatedOffer[]> {
  const { data } = await axios.get<{ success: true; data: AuthenticatedOffer[] }>(offersUrl);
  return data.data;
}
